import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import * as types from '../types'

const fetchCustomerEventsQuery = `
  query ShopifyCustomerEventsQuery(
    $customerId: ID!,
    $limit: Int!
  ) {
    customer(id: $customerId) {
      id
      events(first: $limit, reverse: true) {
        edges {
          node {
            id
            createdAt
            attributeToApp
            attributeToUser
            appTitle
            message
            __typename
            ... on CommentEvent {
              rawMessage
            }
          }
        }
      }
    }
  }
`

export default function doFetchEvents(integrationId, customerGid, limit) {
  return dispatch => {
    const variables = { customerId: customerGid, limit }
    return dispatch(
      doGraphqlRequest(
        types.FETCH_CUSTOMER_EVENTS_REQUEST,
        fetchCustomerEventsQuery,
        variables,
        {
          graphqlFunc: graphql(integrationId),
        }
      )
    )
  }
}
